export default function BrowserMockup({ img, url, name }) {
  return (
    <div className="overflow-hidden rounded-xl border border-ink/10 bg-white shadow-[0_24px_60px_-24px_rgba(7,17,31,0.35)]">
      <div className="flex items-center gap-1.5 border-b border-ink/10 bg-mist px-4 py-2.5">
        <span className="h-2.5 w-2.5 rounded-full bg-[#FF5F57]" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#FEBC2E]" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#28C840]" />
        <span className="ml-3 truncate rounded-full border border-ink/10 bg-white px-3 py-0.5 text-[11px] text-slate-500">{url}</span>
      </div>
      <img src={img} alt={`${name} — screenshot`} loading="lazy" className="block w-full" width="1366" height="850" />
    </div>
  );
}
